export default "__VITE_ASSET__BG$TVSPJ__"